var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c("FabricSelector", {
        attrs: {
          title: "Shutter Type",
          value: _vm.item.fabric,
          fabricGroupID: _vm.selectedFabricGroup,
          v: _vm.$v.item.fabric,
          error: _vm.$v.item.fabric.$error
        },
        on: {
          "selected-fabric": function($event) {
            _vm.selectedFabric = $event
          }
        }
      }),
      _vm._v(" "),
      _c("ColorSelector", {
        attrs: {
          fabricID: _vm.selectedFabric,
          value: _vm.item.color,
          v: _vm.$v.item.color,
          error: _vm.$v.item.color.$error
        },
        on: {
          "selected-color": function($event) {
            _vm.selectedColor = $event
          }
        }
      }),
      _vm._v(" "),
      _c("h4", { staticClass: "mb-4" }, [_vm._v("Layout")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout row wrap" },
        [
          _c(
            "v-flex",
            {
              class:
                _vm.item.variations.layout === "Box Bay" ? "elevation-2" : "",
              attrs: { xs12: "", sm4: "", tile: "" },
              on: {
                click: function($event) {
                  return _vm.selectOption("Box Bay")
                }
              }
            },
            [
              _c("v-img", {
                attrs: { src: "/static/shutterAssets/box-bay.png" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              class:
                _vm.item.variations.layout === "45 Degree Bay"
                  ? "elevation-2"
                  : "",
              attrs: { xs12: "", sm4: "", tile: "" },
              on: {
                click: function($event) {
                  return _vm.selectOption("45 Degree Bay")
                }
              }
            },
            [
              _c("v-img", {
                attrs: { src: "/static/shutterAssets/45-degree-bay.png" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              class:
                _vm.item.variations.layout === "Corner" ? "elevation-2" : "",
              attrs: { xs12: "", sm4: "", tile: "" },
              on: {
                click: function($event) {
                  return _vm.selectOption("Corner")
                }
              }
            },
            [
              _c("v-img", {
                attrs: { src: "/static/shutterAssets/corner.png" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", { staticClass: "mt-3" }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Fitting",
          value: _vm.item.variations.fitting,
          options: ["Face", "Recess"],
          v: _vm.$v.item.variations.fitting,
          error: _vm.$v.item.variations.fitting.$error
        },
        on: {
          "selected-option": function($event) {
            ;(_vm.item.variations.fitting = $event),
              _vm.changeFrameOptions($event)
          }
        }
      }),
      _vm._v(" "),
      _c("DimensionSelector", {
        ref: "dimensionSelector",
        attrs: {
          valueName: _vm.item.name,
          valueWidth: _vm.item.width,
          valueDrop: _vm.item.drop,
          type: this.item.type
        },
        on: {
          room: function($event) {
            return _vm.setRoom($event)
          },
          ready: function(isReady) {
            return (_vm.readyToSubmitDimension = isReady)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "shutter3D" }, [
        _c("h4", { staticClass: "mb-4" }, [_vm._v("Width")]),
        _vm._v(" "),
        _c("div", { staticStyle: { width: "100%", "text-align": "center" } }, [
          _c("img", {
            staticClass: "xs6",
            staticStyle: { width: "90%" },
            attrs: { src: _vm.getImageSrc(), alt: "" }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "layout row wrap" },
          [
            _c(
              "v-flex",
              { attrs: { xs12: "", sm2: "", tile: "" } },
              [
                _c("h4", { staticClass: "mb-4" }, [_vm._v("Left")]),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: { label: "Width" },
                  model: {
                    value: _vm.item.variations.widthLeft,
                    callback: function($$v) {
                      _vm.$set(_vm.item.variations, "widthLeft", $$v)
                    },
                    expression: "item.variations.widthLeft"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm3: "", tile: "" } },
              [
                _c("CustomizationSelector", {
                  attrs: {
                    title: "Panel Count",
                    value: _vm.item.variations.panelLeft,
                    options: _vm.panelOptions,
                    v: _vm.$v.item.variations.panelLeft,
                    error: _vm.$v.item.variations.panelLeft.$error
                  },
                  on: {
                    "selected-option": function($event) {
                      ;(_vm.item.variations.panelLeft = $event),
                        _vm.getPanelCombinations("Left"),
                        _vm.resetpanelWidths("Left")
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm7: "", tile: "" } },
              [
                _c("CustomizationSelector", {
                  attrs: {
                    title: "Panel Combination",
                    value: _vm.item.variations.panelCombinationLeft,
                    options: _vm.panelCombinationsLeft,
                    v: _vm.$v.item.variations.panelCombinationLeft,
                    error: _vm.$v.item.variations.panelCombinationLeft.$error
                  },
                  on: {
                    "selected-option": function($event) {
                      _vm.item.variations.panelCombinationLeft = $event
                    }
                  }
                }),
                _vm._v(" "),
                ["3", "4", "6"].includes(_vm.item.variations.panelLeft)
                  ? _c("CustomizationSelector", {
                      attrs: {
                        title: "Panel Widths Left",
                        value: _vm.item.variations.panelWidthsLeft,
                        options: ["Even Panels", "Custom Panels"],
                        v: _vm.$v.item.variations.panelWidthsLeft,
                        error: _vm.$v.item.variations.panelWidthsLeft.$error
                      },
                      on: {
                        "selected-option": function($event) {
                          ;(_vm.item.variations.panelWidthsLeft = $event),
                            _vm.resetTPostMeasurements("Left")
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.variations.panelWidthsLeft === "Custom Panels"
                  ? _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c("v-flex", { attrs: { xs12: "" } }, [
                          _c("h4", [_vm._v("T Post Measurements Left")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm6: "" } },
                          [
                            _vm.panelMeasurementsErrLeft &&
                            !_vm.item.variations.panelMeasurementsLeft[0]
                              ? _c("div", { staticClass: "red--text" }, [
                                  _vm._v(
                                    "Please enter T Post Left Measurement 1"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "A" },
                              model: {
                                value:
                                  _vm.item.variations.panelMeasurementsLeft[0],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.item.variations.panelMeasurementsLeft,
                                    0,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.variations.panelMeasurementsLeft[0]"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        (
                          _vm.item.variations.panelCombinationLeft.match(
                            /T Post/g
                          ) || []
                        ).length === 2
                          ? _c(
                              "v-flex",
                              { attrs: { xs12: "", sm6: "" } },
                              [
                                _vm.panelMeasurementsErrLeft &&
                                !_vm.item.variations.panelMeasurementsLeft[1]
                                  ? _c("div", { staticClass: "red--text" }, [
                                      _vm._v(
                                        "Please enter T Post Left Measurement 2"
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: { label: "B" },
                                  model: {
                                    value:
                                      _vm.item.variations
                                        .panelMeasurementsLeft[1],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.variations
                                          .panelMeasurementsLeft,
                                        1,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item.variations.panelMeasurementsLeft[1]"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.item.variations.layout !== "Corner"
          ? _c(
              "div",
              { staticClass: "layout row wrap" },
              [
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm2: "", tile: "" } },
                  [
                    _c("h4", { staticClass: "mb-4" }, [_vm._v("Middle")]),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: { label: "Width" },
                      model: {
                        value: _vm.item.variations.widthMiddle,
                        callback: function($$v) {
                          _vm.$set(_vm.item.variations, "widthMiddle", $$v)
                        },
                        expression: "item.variations.widthMiddle"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm3: "", tile: "" } },
                  [
                    _c("CustomizationSelector", {
                      attrs: {
                        title: "Panel Count",
                        value: _vm.item.variations.panelMiddle,
                        options: _vm.panelOptions,
                        v: _vm.$v.item.variations.panelMiddle,
                        error: _vm.$v.item.variations.panelMiddle.$error
                      },
                      on: {
                        "selected-option": function($event) {
                          ;(_vm.item.variations.panelMiddle = $event),
                            _vm.getPanelCombinations("Middle"),
                            _vm.resetpanelWidths("Middle")
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm7: "", tile: "" } },
                  [
                    _c("CustomizationSelector", {
                      attrs: {
                        title: "Panel Combination",
                        value: _vm.item.variations.panelCombinationMiddle,
                        options: _vm.panelCombinationsMiddle,
                        v: _vm.$v.item.variations.panelCombinationMiddle,
                        error:
                          _vm.$v.item.variations.panelCombinationMiddle.$error
                      },
                      on: {
                        "selected-option": function($event) {
                          _vm.item.variations.panelCombinationMiddle = $event
                        }
                      }
                    }),
                    _vm._v(" "),
                    ["3", "4", "6"].includes(_vm.item.variations.panelMiddle)
                      ? _c("CustomizationSelector", {
                          attrs: {
                            title: "Panel Widths Middle",
                            value: _vm.item.variations.panelWidthsMiddle,
                            options: ["Even Panels", "Custom Panels"],
                            v: _vm.$v.item.variations.panelWidthsMiddle,
                            error:
                              _vm.$v.item.variations.panelWidthsMiddle.$error
                          },
                          on: {
                            "selected-option": function($event) {
                              ;(_vm.item.variations.panelWidthsMiddle = $event),
                                _vm.resetTPostMeasurements("Middle")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.variations.panelWidthsMiddle === "Custom Panels"
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          [
                            _c("v-flex", { attrs: { xs12: "" } }, [
                              _c("h4", [_vm._v("T Post Measurements Middle")])
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs12: "", sm6: "" } },
                              [
                                _vm.panelMeasurementsErrMiddle &&
                                !_vm.item.variations.panelMeasurementsMiddle[0]
                                  ? _c("div", { staticClass: "red--text" }, [
                                      _vm._v(
                                        "Please enter T Post Middle Measurement 1"
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: { label: "A" },
                                  model: {
                                    value:
                                      _vm.item.variations
                                        .panelMeasurementsMiddle[0],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.variations
                                          .panelMeasurementsMiddle,
                                        0,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item.variations.panelMeasurementsMiddle[0]"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            (
                              _vm.item.variations.panelCombinationMiddle.match(
                                /T Post/g
                              ) || []
                            ).length === 2
                              ? _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm6: "" } },
                                  [
                                    _vm.panelMeasurementsErrMiddle &&
                                    !_vm.item.variations
                                      .panelMeasurementsMiddle[1]
                                      ? _c(
                                          "div",
                                          { staticClass: "red--text" },
                                          [
                                            _vm._v(
                                              "Please enter T Post Middle Measurement 2"
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      attrs: { label: "B" },
                                      model: {
                                        value:
                                          _vm.item.variations
                                            .panelMeasurementsMiddle[1],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item.variations
                                              .panelMeasurementsMiddle,
                                            1,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "item.variations.panelMeasurementsMiddle[1]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "layout row wrap" },
          [
            _c(
              "v-flex",
              { attrs: { xs12: "", sm2: "", tile: "" } },
              [
                _c("h4", { staticClass: "mb-4" }, [_vm._v("Right")]),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: { label: "Width" },
                  model: {
                    value: _vm.item.variations.widthRight,
                    callback: function($$v) {
                      _vm.$set(_vm.item.variations, "widthRight", $$v)
                    },
                    expression: "item.variations.widthRight"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm3: "", tile: "" } },
              [
                _c("CustomizationSelector", {
                  attrs: {
                    title: "Panel Count",
                    value: _vm.item.variations.panelRight,
                    options: _vm.panelOptions,
                    v: _vm.$v.item.variations.panelRight,
                    error: _vm.$v.item.variations.panelRight.$error
                  },
                  on: {
                    "selected-option": function($event) {
                      ;(_vm.item.variations.panelRight = $event),
                        _vm.getPanelCombinations("Right"),
                        _vm.resetpanelWidths("Right")
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm7: "", tile: "" } },
              [
                _c("CustomizationSelector", {
                  attrs: {
                    title: "Panel Combination",
                    value: _vm.item.variations.panelCombinationRight,
                    options: _vm.panelCombinationsRight,
                    v: _vm.$v.item.variations.panelCombinationRight,
                    error: _vm.$v.item.variations.panelCombinationRight.$error
                  },
                  on: {
                    "selected-option": function($event) {
                      _vm.item.variations.panelCombinationRight = $event
                    }
                  }
                }),
                _vm._v(" "),
                ["3", "4", "6"].includes(_vm.item.variations.panelRight)
                  ? _c("CustomizationSelector", {
                      attrs: {
                        title: "Panel Widths Right",
                        value: _vm.item.variations.panelWidthsRight,
                        options: ["Even Panels", "Custom Panels"],
                        v: _vm.$v.item.variations.panelWidthsRight,
                        error: _vm.$v.item.variations.panelWidthsRight.$error
                      },
                      on: {
                        "selected-option": function($event) {
                          ;(_vm.item.variations.panelWidthsRight = $event),
                            _vm.resetTPostMeasurements("Right")
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.variations.panelWidthsRight === "Custom Panels"
                  ? _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c("v-flex", { attrs: { xs12: "" } }, [
                          _c("h4", [_vm._v("T Post Measurements Right")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm6: "" } },
                          [
                            _vm.panelMeasurementsErrRight &&
                            !_vm.item.variations.panelMeasurementsRight[0]
                              ? _c("div", { staticClass: "red--text" }, [
                                  _vm._v(
                                    "Please enter T Post Right Measurement 1"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "A" },
                              model: {
                                value:
                                  _vm.item.variations.panelMeasurementsRight[0],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.item.variations.panelMeasurementsRight,
                                    0,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.variations.panelMeasurementsRight[0]"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        (
                          _vm.item.variations.panelCombinationRight.match(
                            /T Post/g
                          ) || []
                        ).length === 2
                          ? _c(
                              "v-flex",
                              { attrs: { xs12: "", sm6: "" } },
                              [
                                _vm.panelMeasurementsErrRight &&
                                !_vm.item.variations.panelMeasurementsRight[1]
                                  ? _c("div", { staticClass: "red--text" }, [
                                      _vm._v(
                                        "Please enter T Post Right Measurement 2"
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: { label: "B" },
                                  model: {
                                    value:
                                      _vm.item.variations
                                        .panelMeasurementsRight[1],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.variations
                                          .panelMeasurementsRight,
                                        1,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item.variations.panelMeasurementsRight[1]"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("v-divider", { staticClass: "mt-3" }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Frame",
          value: _vm.item.variations.frame,
          options: _vm.frameOptions,
          v: _vm.$v.item.variations.frame,
          error: _vm.$v.item.variations.frame.$error
        },
        on: {
          "selected-option": function($event) {
            ;(_vm.item.variations.frame = $event),
              $event === "No Frame"
                ? (_vm.item.variations.frameType = null)
                : ""
          }
        }
      }),
      _vm._v(" "),
      _vm.item.variations.frame == "Full Frame" ||
      _vm.item.variations.frame == "3 Sided Frame"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Frame Design",
              value: _vm.item.variations.frameType,
              options: _vm.frameDesigns,
              v: _vm.$v.item.variations.frameType,
              error: _vm.$v.item.variations.frameType.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.frameType = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Midrail",
          value: _vm.item.variations.rail,
          options:
            _vm.item.drop < 1600
              ? ["No Rail", "Single Rail", "Double Rail"]
              : ["Single Rail", "Double Rail"],
          v: _vm.$v.item.variations.rail,
          error: _vm.$v.item.variations.rail.$error
        },
        on: {
          "selected-option": function($event) {
            ;(_vm.item.variations.rail = $event), _vm.resetMidRailHeight($event)
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Hinge Colour",
          value: _vm.item.variations.hingeColor,
          options: ["White", "Beige", "Chrome", "Anodised Silver"],
          v: _vm.$v.item.variations.hingeColor,
          error: _vm.$v.item.variations.hingeColor.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.hingeColor = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.incInstall
        ? _c(
            "div",
            [
              _c("v-checkbox", {
                attrs: { label: "Install?", color: "primary" },
                model: {
                  value: _vm.customInstall,
                  callback: function($$v) {
                    _vm.customInstall = $$v
                  },
                  expression: "customInstall"
                }
              }),
              _vm._v(" "),
              _vm.customInstall
                ? _c("v-text-field", {
                    attrs: { label: "Install Price" },
                    model: {
                      value: _vm.item.installPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "installPrice", $$v)
                      },
                      expression: "item.installPrice"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      ["Single Rail", "Double Rail"].includes(_vm.item.variations.rail)
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Midrail Alignment",
              value: _vm.item.variations.railAlignment,
              options: ["Even Alignment", "Uneven Alignment"],
              v: _vm.$v.item.variations.railAlignment,
              error: _vm.$v.item.variations.railAlignment.$error
            },
            on: {
              "selected-option": function($event) {
                ;(_vm.item.variations.railAlignment = $event),
                  _vm.resetMidRailHeight()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.railAlignment === "Uneven Alignment"
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c("v-flex", { attrs: { xs12: "" } }, [
                _c("h4", [_vm._v("Midrail Measurement")])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "" } },
                [
                  _vm.railMeasurementErr &&
                  !_vm.item.variations.railMeasurement[0]
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please enter Midrail Height 1")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "A" },
                    model: {
                      value: _vm.item.variations.railMeasurement[0],
                      callback: function($$v) {
                        _vm.$set(_vm.item.variations.railMeasurement, 0, $$v)
                      },
                      expression: "item.variations.railMeasurement[0]"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.item.variations.rail === "Double Rail"
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _vm.railMeasurementErr &&
                      !_vm.item.variations.railMeasurement[1]
                        ? _c("div", { staticClass: "red--text" }, [
                            _vm._v("Please enter Midrail Height 2")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "B" },
                        model: {
                          value: _vm.item.variations.railMeasurement[1],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.item.variations.railMeasurement,
                              1,
                              $$v
                            )
                          },
                          expression: "item.variations.railMeasurement[1]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-textarea", {
        attrs: { name: "notes", label: "Line Item Notes" },
        model: {
          value: _vm.item.notes,
          callback: function($$v) {
            _vm.$set(_vm.item, "notes", $$v)
          },
          expression: "item.notes"
        }
      }),
      _vm._v(" "),
      !_vm.edit
        ? _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Add " + _vm._s(_vm.item.type))]
          )
        : _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Update " + _vm._s(_vm.item.type))]
          ),
      _vm._v(" "),
      _c("b", [_vm._v("$" + _vm._s(_vm.item.total.toFixed(2)))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bf616ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bf616ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Shutter3D.vue
// module id = null
// module chunks = 